import React from 'react'
import PropTypes from 'prop-types'

const KeyTakeaways = ({ list }) => {
  return (
    <div
      id="keyTakeaways"
      className="border-y py-4 text-base"
      data-testid="key-takeaways"
    >
      <span className="font-medium leading-7" data-testid="keyTakeaways-title">
        Key Takeaways:
      </span>
      <ul className="mt-4 list-disc pl-5">
        {list.map((item, index) => (
          <li key={index} className="my-0.5 text-base leading-7">
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

KeyTakeaways.propTypes = {
  list: PropTypes.array.isRequired,
}

export default KeyTakeaways
